import Vue from 'vue'
import Vuex from 'vuex'
import error from './error.module'
import auth from './auth.module'
import loading from './loading.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    error,
    auth,
    loading
  }
})